import { PremiumFeatureAccessLevel } from '@sdk/authentication/types';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';

import { FeatureNames } from '@web/account/types';
import useGetPaidFeatureList from '@web/premiumGuard/hooks/useGetPaidFeatureList';
import getPremiumAccessLevelName from '@web/premiumGuard/ModalGuard/helpers/getPremiumAccessLevelName';

type Props = {
  currentUser: AuthUserType;
  premiumFeatureAccessLevel: PremiumFeatureAccessLevel;
  premiumFeatureName: FeatureNames;
};
export const useModalGuard = ({
  currentUser,
  premiumFeatureAccessLevel,
  premiumFeatureName,
}: Props) => {
  const { isOldPremium } = currentUser.orgSettings;
  const { isToastBilling } = currentUser.org;

  const accessLevelName = getPremiumAccessLevelName({
    premiumFeatureAccessLevel,
    isOldPremium,
    isToastBilling,
  });

  /**
   * needs 8 features to display as additional information about other available features
   */
  const firstEightFeatures = useGetPaidFeatureList({
    currentUser,
    hiddenKeys: [premiumFeatureName],
    featureAccessLevel: premiumFeatureAccessLevel,
  }).slice(0, 8);

  return { accessLevelName, firstEightFeatures };
};
